import React, { useEffect, useState } from 'react';
import api from '../api';

import {
    $getSelection,
    $setSelection,
    $isRangeSelection,
    FORMAT_TEXT_COMMAND,
    UNDO_COMMAND,
    REDO_COMMAND,
    $createTextNode,
    $createRangeSelection,
    $getRoot,
} from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createHeadingNode, $isHeadingNode } from '@lexical/rich-text';

const TableFiller = ({ project }) => {

    const [editor] = useLexicalComposerContext();

    useEffect(() => {

        editor.update(() => {
            const root = $getRoot();

            root.append(heading('h1', project.table.title));

            project.table.chapters.forEach((chapter) => {

                root.append(heading('h2', chapter.name));
                chapter.subchapters.forEach((subchapter) => {
                    root.append(heading('h3', subchapter));
                });
            });

            // Delete first editor empty child
            const firstChild = root.getFirstChild();
            if (firstChild && firstChild.getTextContent().trim() === '') {
                firstChild.remove();
            }

            saveContent();
        });

    }, []);

    const heading = (tag, text) => {

        const newHeading = $createHeadingNode(tag);
        const textNode = $createTextNode(text);
        newHeading.append(textNode);

        return newHeading;
    }

    const saveContent = () => {
        editor.update(() => {
            const editorState = editor.getEditorState();
            const content = JSON.stringify(editorState.toJSON());

            api.post('/update_content', {
                projectId: project.project_id,
                content: content
            })
                .then((response) => {
                    console.log(response.data.message);
                })
                .catch((error) => {
                    console.error('Content save error :', error);
                });
        });
    };

}

export default TableFiller;